import dayjs from 'dayjs';

/**
 * Format ISO date string to display format
 * Example: "2025-08-17T00:00:00Z" -> "17 Aug 2025"
 */
export function formatDate(isoDate: string | null): string {
  if (!isoDate) return '—';
  return dayjs(isoDate).format('DD MMM YYYY');
}

/**
 * Format relative time
 * Example: "2025-08-17T00:00:00Z" -> "2 days ago"
 */
export function formatRelativeDate(isoDate: string | null): string {
  if (!isoDate) return '—';
  return dayjs(isoDate).fromNow();
}

/**
 * Get initials from vendor name for avatar fallback
 * Example: "Asana" -> "AS", "Google Cloud" -> "GC"
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
